// Utils
import faqUrl from '@/utils/urls/faqUrl';

// Type
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Lib
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    THREADS,
    TIKTOK_BUSINESS,
    TWITTER,
    X,
    YOUTUBE
} from '@/lib/socialProfile';
import { url_faq_estimated_followers_media_viewer } from '@/lib/urls/faqUrls';

// Components
import LinkBase from '@/components/base/LinkBase';
import { Trans } from '@/components/tools/translation';

const bannerTranslation: Record<SocialProfileNetworkType, string> = {
    [INSTAGRAM]: 'analytics:estimated_data_media_viewer',
    [FACEBOOK]: 'analytics:estimated_data_media_viewer',
    [LINKEDIN]: 'analytics:linkedin_estimated_data_media_viewer',
    [TWITTER]: 'analytics:twitter_estimated_data_media_viewer',
    [X]: 'analytics:twitter_estimated_data_media_viewer',
    [TIKTOK_BUSINESS]: 'analytics:tiktok_estimated_data_media_viewer',
    [YOUTUBE]: 'analytics:estimated_data_media_viewer',
    [PINTEREST]: 'analytics:estimated_data_media_viewer',
    [THREADS]: 'analytics:estimated_data_media_viewer'
};

const MediaViewerEstimatedStatsBanner = ({ network }: { network: SocialProfileNetworkType }) => {
    return (
        <Trans
            i18nKey={bannerTranslation[network]}
            components={{
                tag0: (
                    <LinkBase
                        key="learn_more"
                        className="inline-block underline"
                        target="_blank"
                        href={faqUrl(url_faq_estimated_followers_media_viewer)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    );
};

export default MediaViewerEstimatedStatsBanner;
